import type {
  SmtDineInDispatchResult,
  SmtDineInIntent,
  SmtDineInRequest,
  SmtDineInViewModel,
} from '../../../packages/runtime/smt-dine-in-contract.ts';

type StripDineInRuntimeContext<T> = T extends SmtDineInIntent
  ? Omit<T, 'context'> & {
      readonly context: Omit<T['context'], 'idempotencyKey' | 'actorId' | 'at'>;
    }
  : never;

export type SmtDineInUiIntent = StripDineInRuntimeContext<SmtDineInIntent>;
export type {SmtDineInDispatchResult, SmtDineInRequest, SmtDineInViewModel};

export interface SmtDineInSurfacePort {
  readonly snapshot: (request: SmtDineInRequest) => SmtDineInViewModel;
  readonly dispatch: (intent: SmtDineInIntent, request: SmtDineInRequest) => SmtDineInDispatchResult;
}

export interface SmtDineInPortConfig {
  readonly surface: SmtDineInSurfacePort;
  readonly operatorId: string;
  readonly now: () => string;
  readonly nextId: () => string;
}

export interface SmtDineInPort {
  readonly read: (request?: SmtDineInRequest) => Promise<SmtDineInViewModel>;
  readonly dispatch: (intent: SmtDineInUiIntent, request?: SmtDineInRequest) => Promise<SmtDineInDispatchResult>;
}

export function createSmtDineInPort(config: SmtDineInPortConfig): SmtDineInPort {
  return {
    async read(request = {}) {
      return config.surface.snapshot(request);
    },
    async dispatch(intent, request = {}) {
      const upstreamIntent = {
        ...intent,
        context: {
          ...intent.context,
          idempotencyKey: config.nextId(),
          actorId: config.operatorId,
          at: config.now(),
        },
      } as SmtDineInIntent;
      return config.surface.dispatch(upstreamIntent, request);
    },
  };
}
